import React from 'react';
import PropTypes from 'prop-types';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Col, Row } from 'reactstrap';
import { Input, Tooltip, Icon } from 'antd';
import messages from './messages';
import reducer from './reducer';
import saga from './saga';

import { getServices, servicesSelected } from './actions';
import { makeSelectServices, makeSelectSelectedServices,
  makeSelectProductServices } from './selectors';

import { ItemBox, FlexSection } from '../UIKit';

import './styles.scss';

class OfferServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
    };
  }

  componentDidMount() {
    this.props.loadServices();
  }

  handelOnClick(value) {
    let { selected } = this.state;
    const { services } = this.props;

    if (selected.some(item => item.id === value)) {
      selected = selected.filter(item => item.id !== value);
    } else {
      selected.push(services.find(service => service.id === value));
    }

    this.setState({ selected });
    this.props.selectServices(selected);
  }

  handelOnPriceChange(serviceId, value) {
    const { selected } = this.state;
    const serviceIdx = selected.findIndex(selectedService => selectedService.id === serviceId);

    selected[serviceIdx].price = value;

    this.setState({ selected });
    this.props.selectServices([...selected]);
  }

  componentDidUpdate(prevProps) {
    const { selected, productServices } = this.props;

    if (prevProps.selected !== selected || prevProps.productServices !== productServices) {
      let selectedSet = selected;

      if (selectedSet.length === 0) {
        selectedSet = productServices;
      }

      this.setState({ selected: selectedSet });
      this.props.selectServices(selectedSet);
    }
  }

  render() {
    const { services } = this.props;
    const { selected } = this.state;
    const servicesPrices = selected.map(service => ({id: service.id, price: service.price}))
    const servicesFranchises = selected.map(service => ({id: service.id, franchise: service.franchise}))

    if (!Array.isArray(services)) {
      return null;
    }

    return (
      <div id="OfferServices">
        <FlexSection
          title={messages.title.defaultMessage}
          children={
            <div className="item-box-container">
              <Row className="no-gutters">
                {services.filter(service => !service.has_price_map).map((item, key) => {
                  const servicePrice = (servicesPrices.find(servicesPrice => servicesPrice.id === item.id) || item).price;
                  const servicesFranchise = (servicesFranchises.find(servicesFranchise => servicesFranchise.id === item.id) || item).franchise;
                  const serviceTitle = `${item.name} ${servicePrice ? `${servicePrice}€` : ''}`;
                  let serviceDescription = item.description;

                  if (item.min_quantity !== item.max_quantity) {
                    serviceDescription += ` (quantità selezionabile da ${item.min_quantity} a ${item.max_quantity})`;
                  }

                  return <Col md={4} sm={6} className="padding-bottom" key={key}>
                    <ItemBox
                      title={serviceTitle}
                      description={serviceDescription}
                      icon={item.icon}
                      isSelected={selected.some(selectedItem => selectedItem.id === item.id)}
                      onClick={() => this.handelOnClick(item.id)}
                      children={
                        !item.included ?
                          <Input
                            className="text-right"
                            min={0}
                            max={1000}
                            maxLength={5}
                            type="number"
                            suffix="€"
                            size="small"
                            placeholder={`${servicePrice}`}
                            title="Personalizza il prezzo del servizio per questa offerta"
                            onChange={({target: {value}}) => this.handelOnPriceChange(item.id, value)}
                            onClick={event => event.stopPropagation()}
                            disabled={!selected.some(selectedItem => selectedItem.id === item.id)}
                          />
                          :
                          <span className="text-right">
                            {servicesFranchise && `${servicesFranchise}`}
                          </span>
                      }
                    />
                  </Col>
                })}
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}

OfferServices.defaultProps = {};
OfferServices.propTypes = {
  services: PropTypes.any.isRequired,
  loadServices: PropTypes.func.isRequired,
  selectServices: PropTypes.func.isRequired,
  selected: PropTypes.any,
};

export function mapDispatchToProps(dispatch) {
  return {
    loadServices: () => dispatch(getServices()),
    selectServices: services => dispatch(servicesSelected(services)),
  };
}

const mapStateToProps = createStructuredSelector({
  services: makeSelectServices(),
  selected: makeSelectSelectedServices(),
  productServices: makeSelectProductServices(),
});

const withReducer = injectReducer({ key: 'services', reducer });
const withSaga = injectSaga({ key: 'services', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(OfferServices);
